import React, { createContext } from 'react';

enum Page {
  Home = 'homepage',
  Explore = 'explore',
  Trail = 'trail',
  Seo = 'seo',
  Unknown = 'unknown'
}

type PageProviderProps = {
  page: Page;
  children: React.ReactNode;
};

/**
 * A context used to share the current page across components.
 */
const PageContext = createContext<Page>(Page.Unknown);
PageContext.displayName = 'PageContext';

/**
 * A provider for the current page viewed.
 */
const PageProvider = ({ page, children }: PageProviderProps): JSX.Element => <PageContext.Provider value={page}>{children}</PageContext.Provider>;

export { Page, PageContext, PageProvider };
